import { Col, Container, Figure, Row } from "react-bootstrap";
import Stormy from "../assets/stormy.webp";
import Zaru from "../assets/zaru.webp";
import Magrethe from "../assets/Magrethe.jpg";
import Ingrid from "../assets/Ingrid.jpg";

export default function Employees() {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <p className="text-center">For a serotonin boost meet our purrfect employees:</p>
                </Col>
            </Row>
            <Row className=" row-cols-2 row-cols-xl-4">
                <Col>
                    <Figure>
                        <Figure.Image src={Stormy} className="rounded " alt="Catployee Picture Stormy" />
                        <Figure.Caption className="fw-bold">Stormy, the Analyst</Figure.Caption>
                    </Figure>
                </Col>
                <Col>
                    <Figure>
                        <Figure.Image src={Zaru} className="rounded" alt="Catployee Picture Zaru" />
                        <Figure.Caption className="fw-bold">Zaru, the Data Engineer</Figure.Caption>
                    </Figure>
                </Col>
                <Col>
                    <Figure>
                        <Figure.Image src={Ingrid} className="rounded" alt="Catployee Picture Ingrid" />
                        <Figure.Caption className="fw-bold">Ingrid, the Sales Director</Figure.Caption>
                    </Figure>
                </Col>
                <Col>
                    <Figure>
                        <Figure.Image src={Magrethe} className="rounded" alt="Catployee Picture Magrethe" />
                        <Figure.Caption className="fw-bold h">Magrethe, the Project Manager</Figure.Caption>
                    </Figure>
                </Col>
            </Row>
        </Container>
    );
}
